'use strict';
var DropShipShippingAddressListService = /** @class */ (function () {
    /*@ngInject*/
    function DropShipShippingAddressListService($http, $log, Util, Auth) {
        this.$http = $http;
        this.$log = $log;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.Auth = Auth;
    }
    /*@ngInject*/
    DropShipShippingAddressListService.prototype.getDropShipAddresses = function (pageNumber, pageSize) {
        var request = this.$http({
            method: "get",
            url: "api/account/address/dropship",
            params: {
                "pageNumber": pageNumber ? pageNumber : 1,
                "pageSize": pageSize ? pageSize : 10
            }
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    DropShipShippingAddressListService.prototype.deleteAddress = function (addressId) {
        this.Auth.clearAccountCache();
        var self = this;
        return this.$http.delete('api/account/address/' + addressId)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('success response.....', response);
            }
            else {
                self.$log.error('api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('error response.....', response);
            return response;
        });
    };
    DropShipShippingAddressListService.prototype.addShippingAddress = function (address) {
        this.Auth.clearAccountCache();
        var self = this;
        var addrPayload = {};
        addrPayload.recipientName = address.recipientName;
        addrPayload.isDefault = address.isDefault;
        addrPayload.line1 = address.address1;
        addrPayload.line2 = address.address2;
        addrPayload.city = address.city;
        addrPayload.regionCode = address.state.regionCode;
        addrPayload.regionName = address.state.regionName;
        addrPayload.postalCode = address.postalCode;
        addrPayload.countryCode = address.country.countryCode;
        addrPayload.countryName = address.country.countryName;
        addrPayload.isDropShip = true;
        addrPayload.addressType = 1;
        self.$log.debug('Adding this Drop Ship Address in service:', addrPayload);
        return this.$http.post('api/account/address/', addrPayload)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('add Drop Ship address success response.....', response);
            }
            else {
                self.$log.error('add Drop Ship address returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('add drop ship address error response.....', response);
            return response;
        });
    };
    DropShipShippingAddressListService.prototype.findDropShipAddressesBySearchTerm = function (searchTerm, pageNumber, pageSize) {
        var queryParams = {};
        if (searchTerm == "" || searchTerm == undefined) {
            queryParams = {
                "pageNumber": 1,
                "pageSize": pageSize ? pageSize : 10
            };
        }
        else {
            queryParams = {
                "searchTerm": searchTerm,
                "pageNumber": pageNumber ? pageNumber : 1,
                "pageSize": pageSize ? pageSize : 10
            };
        }
        var request = this.$http({
            method: "GET",
            url: "api/account/address/dropship/",
            params: queryParams
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    return DropShipShippingAddressListService;
}());
export default DropShipShippingAddressListService;
//# sourceMappingURL=drop-ship-shipping-address-list.service.js.map